import { useMemo } from 'react';

import nullSafeItems from '@lyearn/core/utils/array/nullSafeItems';
import { Maybe, SortType, TagsFilters, TagUnion } from '@/types/schema';

import { useTagsWithIntegrationProviderQuery } from '../../graphql/generated/tagsWithIntegrationProvider';

function useTagsWithIntegrationProvider({
  filters,
  sort,
  first,
  pause = false,
}: {
  filters: TagsFilters;
  sort?: Maybe<SortType[]>;
  first?: number;
  pause?: boolean;
}) {
  const [{ data, fetching, error }, refetch] = useTagsWithIntegrationProviderQuery({
    variables: {
      filters,
      sort,
      first,
    },
    pause,
  });

  const tags = useMemo(() => {
    const tagEdges = data?.tagsInfo?.edges ? nullSafeItems(data?.tagsInfo?.edges) : undefined;
    return (tagEdges?.map(({ node }) => node) || []) as TagUnion[];
  }, [data?.tagsInfo?.edges]);

  const totalCount = data?.tagsInfo?.totalCount;

  return {
    isLoading: fetching,
    isFetching: fetching,
    isFetchingMore: false,
    error,
    tags,
    totalCount,
    refetch,
    fetchMore: undefined,
  };
}

export default useTagsWithIntegrationProvider;
